export const URL = "https://smsc.datagenit.com/apismpp/v1/"; // local
export const URLEC2 = "https://smpp.datagenit.com/";
